import axios from "axios";

//Authentication
export function getAuthCookie() {
  return axios.get(process.env.VUE_APP_API_URL + "Auth/Cookie");
}

export function getUserInfo() {
  return axios.get(process.env.VUE_APP_API_URL + "Auth/userinfo");
}

export function logout() {
  return axios.get(process.env.VUE_APP_API_URL + "Auth/logout");
}

export function login(data) {
  return axios.post(process.env.VUE_APP_API_URL + "Auth/login", data);
}

//Var Olan Kayıt Kontrolü
export function getExistUser(data) {
  const config = {
    params: {
      FirstName: data.firstName,
      LastName: data.lastName,
      DateOfBirth: data.dateOfBirth,
      NationalitysId: data.nationalitysId,
      NationalitysId2: data.nationalitysId2,
      NationalitysId3: data.NationalitysId3,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/recordcontrol", config);
}

export function getIsValidEmail(email) {
  const config = {
    params: {
      email: email,
    },
  };
  return axios.get(process.env.VUE_APP_API_URL + "Class/emailcontrol", config);
}

//Giriş yapan kullanıcının rolleri
export function getUserRoleList() {
  return axios.get(process.env.VUE_APP_API_URL + "Auth/rol");
}

//Sınıfa Öğrenci atama
export function postNewStudent(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(process.env.VUE_APP_API_URL + "Auth/register", data, config);
}

export async function postNewStudentWithExcel(data) {
  const config = {
    params: {
      centerId: data.centerId,
      centerPeriodId: data.centerPeriodId,
    },
  };
  return axios.post(process.env.VUE_APP_API_URL + "Auth/registerWithExcel", data.rows, config);
}

//Rol Listesi
export function getRoleList() {
  return axios.get(process.env.VUE_APP_API_URL + "Class/ssorol");
}
